import reportsConfig from '~/constants/data-reports/cobalt'

const cobaltPricingData = {
  hero: reportsConfig.hero,
  descriptions: [
    'The complexity of the cobalt supply chain is renowned, especially from the Democratic Republic of Congo (DRC) into China. Our understanding of this source is central to our Cobalt price and data collection process.',
    'Benchmark’s worldwide connections include producers of cobalt hydroxide, cobalt concentrate, cobalt sulphate, and cobalt metal to cathode makers, battery manufacturers and electric vehicle (EV) majors.',
  ],
  descriptionImage:
    'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1719346124/assets/market/cobalt/cobalt-1_huvz00.jpg',
  brochureFile: {
    category: 'methodology-price-assessments',
    file_name: 'Benchmark-Cobalt-Price-Assessment-Methodology.pdf',
    EnvKey: 'cobaltPriceAssessmentsMethodologyId',
  },
  services: [
    {
      icon: 'services/icon-chart-line',
      description:
        'Create your own custom pricing charts using our bespoke data.',
    },
    {
      icon: 'services/icon-presentation',
      description:
        'Produce custom made representations of data to download for projects and presentations.',
    },
    {
      icon: 'services/icon-consultancy',
      description:
        'Access Benchmark’s exclusive industry commentary collected through our extensive network of industry contacts.',
    },
    {
      icon: 'services/icon-idea',
      description:
        'Our goal is to help you understand the context of our data, not just give you the numbers.',
    },
  ],
  indexTab: true,
  customisationToolTab: true,
  requiredFilters: ['categories', 'shippingRoutes', 'purities', 'priceTypes'],
}
export default cobaltPricingData
